/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChannelUsers
 */
export interface ChannelUsers {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChannelUsers
     */
    users: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ChannelUsers
     */
    creator?: string | null;
}

export function ChannelUsersFromJSON(json: any): ChannelUsers {
    return ChannelUsersFromJSONTyped(json, false);
}

export function ChannelUsersFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChannelUsers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': json['users'],
        'creator': !exists(json, 'creator') ? undefined : json['creator'],
    };
}

export function ChannelUsersToJSON(value?: ChannelUsers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users,
        'creator': value.creator,
    };
}


